import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

/**
 * Three-way "unsaved changes" prompt used by Create/Edit Fund and any
 * other flow that wants Save-as-Draft / Discard / Cancel semantics.
 * The parent owns the actions — this dialog is a thin, testable shell.
 */
export function UnsavedChangesDialog({
  open,
  onOpenChange,
  onSaveDraft,
  onDiscard,
  onCancel,
  saving = false,
  discardLabel = "Discard",
  saveLabel = "Save as Draft",
  cancelLabel = "Cancel",
  title = "Save as draft?",
  description = "You have unsaved changes to this fund. Do you want to save it as a draft?",
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border sm:max-w-md" data-testid="unsaved-changes-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-400" /> {title}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-sm">
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:justify-end">
          <Button
            type="button"
            variant="ghost"
            onClick={onCancel}
            disabled={saving}
            data-testid="unsaved-cancel-btn"
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="border border-border"
            onClick={onDiscard}
            disabled={saving}
            data-testid="unsaved-discard-btn"
          >
            {discardLabel}
          </Button>
          <Button
            type="button"
            onClick={onSaveDraft}
            disabled={saving}
            data-testid="unsaved-save-draft-btn"
          >
            {saving ? "Saving…" : saveLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default UnsavedChangesDialog;
